import React from 'react';

export default function ItemCard({
    title,
    subtitle,
    badge,
    meta,
    description,
    tags,
    importance,
    achievements,
    highlights,
    links,
    onEdit,
    onDelete
}) {
    return (
        <div className="item-card">
            <div className="item-card-header">
                <div className="item-card-info">
                    <div className="item-card-title-row">
                        <h4 className="item-card-title">{title}</h4>
                        {badge && <span className="item-card-badge">{badge}</span>}
                    </div>
                    {subtitle && <p className="item-card-subtitle">{subtitle}</p>}
                </div>
                <div className="item-card-actions">
                    {importance && (
                        <div className="importance-stars">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span key={star} className={`star ${star <= importance ? 'filled' : ''}`}>★</span>
                            ))}
                        </div>
                    )}
                    <button className="action-button" onClick={onEdit} title="Edit">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                        </svg>
                    </button>
                    <button className="action-button delete" onClick={onDelete} title="Delete">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="3 6 5 6 21 6"></polyline>
                            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        </svg>
                    </button>
                </div>
            </div>

            {meta && meta.length > 0 && (
                <div className="item-card-meta">
                    {meta.map((item, index) => (
                        <span key={index}>{item}</span>
                    ))}
                </div>
            )}

            {description && (
                <p className="item-card-description">{description}</p>
            )}

            {(achievements || highlights) && (achievements?.length > 0 || highlights?.length > 0) && (
                <ul className="item-card-highlights">
                    {(achievements || highlights).map((item, index) => (
                        <li key={index}>{item}</li>
                    ))}
                </ul>
            )}

            {links && (links.url || links.github) && (
                <div className="item-card-links">
                    {links.url && (
                        <a href={links.url} target="_blank" rel="noopener noreferrer" className="item-link">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                <polyline points="15 3 21 3 21 9"></polyline>
                                <line x1="10" y1="14" x2="21" y2="3"></line>
                            </svg>
                            Live Demo
                        </a>
                    )}
                    {links.github && (
                        <a href={links.github} target="_blank" rel="noopener noreferrer" className="item-link">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                            </svg>
                            GitHub
                        </a>
                    )}
                </div>
            )}

            {tags && tags.length > 0 && (
                <div className="tags-container">
                    {tags.map((tag, index) => (
                        <span key={index} className="tag">{tag}</span>
                    ))}
                </div>
            )}
        </div>
    );
}
